import request from "@/utils/requestBlog"
const api = {
  getChildrenArticleById: "/column/getChildrenArticleById",
  getArticleById: "/article/getArticleById",
}
export default api
// 获取文章menu树形结构
export function getChildrenArticleById(data) {
  return request({
    url: api.getChildrenArticleById,
    method: "post",
    data,
  })
}
// 获取文章详情
export function getArticleById(data) {
  return request({
    url: api.getArticleById,
    method: "post",
    data: {
      ...data,
      // funlink 1  medpro 2
      platId: 1
    },
  })
}
// 获取推荐文章
export const getRecommendedArticles = (languageFlag) =>
  request({
    url: `/article/recommendedArticles`,
    method: "get",
    params: { languageFlag },
  })
// 文章有无帮助
export const updateThumbsupNum = (data) =>
  request({
    url: "/article/updateThumbsupNum",
    method: "post",
    data,
  })
// 文章分页
export const getMedproArticlePage = (data) =>
  request({
    url: "/article/getMedproArticlePage",
    method: "post",
    data,
  })
// 文章搜索
export const getMedproArticleList = (data) =>
  request({
    url: "/article/getMedproArticleList",
    method: "post",
    data,
  })
